import { render, staticRenderFns } from "./TogetherText.vue?vue&type=template&id=fb6af788&scoped=true"
import script from "./TogetherText.vue?vue&type=script&lang=js"
export * from "./TogetherText.vue?vue&type=script&lang=js"
import style0 from "./TogetherText.vue?vue&type=style&index=0&id=fb6af788&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb6af788",
  null
  
)

export default component.exports